module.exports = __webpack_public_path__ + "static/media/email.cd0e045c.svg";